import React, { useState, useEffect } from "react";
import UploadDocPassPan from "./UploadDocPassPan";
import {
  fraddSettlementAccountForPayout,
  fruploadDocSettlementAccountForPayout,
} from "../api/settalmentApi";
import { dmtBanks } from "../json-data/dmtbanklist";
import { useNotify } from "../context/NotifyContext";
import { useNavigate } from "react-router-dom";
import useBankVerification from "../hooks/useBankVerification";
import BankVerificationBox from "./BankVerificationBox";
import { useSelector } from "react-redux";

const SettlementAccount = ({ open, close }) => {
  const { notify } = useNotify(); // centralized notification
   const { userInfo } = useSelector((state) => state?.auth);
  const navigate = useNavigate();
  const [holderName, setHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [confirmAccount, setConfirmAccount] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [remarks, setRemarks] = useState("");
  const [upiId, setUpiId] = useState("");
  const [qrCodeFile, setQrCodeFile] = useState(null);
  const [qrPreview, setQrPreview] = useState("");
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [bankName, setBankName] = useState("");
  const [bankId, setBankId] = useState("");
  const [allBanks, setAllBanks] = useState([]);
  const [baneId, setBaneId] = useState("");
  const [settlementId, setSettlementId] = useState(null);
  const [uploadOpen, setUploadOpen] = useState(false);

  // const bankVerification = useBankVerification({
  //   accountNumber,
  //   ifsc,
  //   name: holderName,
  //   bankId,
  //   bankName,
  //   sourceType: "SETTLEMENT",
  //   onVerified: (result) => {
  //     if (result.beneficiaryName && !holderName) {
  //       setHolderName(result.beneficiaryName);
  //     }
  //   },
  // });

  // ------------------- BANK LIST -------------------
  const bankVerification = useBankVerification({
  accountNumber,
  ifsc,
  name: holderName,
  bankId,
  bankName,
  sourceType: "SETTLEMENT",
  onVerified: (result) => {
    if (result?.beneficiaryName) {
      setHolderName(result.beneficiaryName);
    }
  },
});
  
  useEffect(() => {
    if (dmtBanks?.length) setAllBanks(dmtBanks);
  }, []);

    useEffect(() => {
    if (userInfo?.phone) setMobile(userInfo?.phone || "");
  }, [userInfo]);

  useEffect(() => () => {
    if (qrPreview) URL.revokeObjectURL(qrPreview);
  }, [qrPreview]);

  // ------------------- SUBMIT ACCOUNT -------------------
  const handleSubmit = async () => {
    // VALIDATIONS
    if (
      !holderName.trim() ||
      !accountNumber.trim() ||
      !confirmAccount.trim() ||
      !ifsc.trim() ||
      !mobile.trim() ||
      !bankId
    ) {
      return notify("Please fill all required fields", "error");
    }

    if (accountNumber !== confirmAccount)
      return notify("Account numbers must match", "error");

    if (!/^\d{9,18}$/.test(accountNumber))
      return notify("Account number must be 9-18 digits", "error");

    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc.trim().toUpperCase()))
      return notify("Enter a valid 11-character IFSC code", "error");

    if (!/^\+?\d{10,15}$/.test(mobile))
      return notify("Enter valid mobile number", "error");

    // Compulsory check: If verification required and not verified yet
    if (bankVerification.verificationRequired && !bankVerification.ready) {
      return notify(
        "Please verify this bank account before adding",
        "warning"
      );
    }

    const cleanUpiId = upiId.trim();
    if (!cleanUpiId && !qrCodeFile) {
      return notify("Configure at least a UPI ID or upload a QR Code", "error");
    }

    if (
      cleanUpiId &&
      !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+$/.test(cleanUpiId)
    ) {
      return notify("Invalid UPI ID", "error");
    }

    const payload = new FormData();
    payload.append("accountHolderName", holderName.trim());
    payload.append("accountNumber", accountNumber.trim());
    payload.append("confirmAccountNumber", confirmAccount.trim());
    payload.append("ifsc", ifsc.trim().toUpperCase());
    payload.append("remarks", remarks.trim());
    payload.append("mobile", mobile.trim());
    payload.append("branch", "");
    payload.append("bankName", bankName);
    payload.append("bankId", bankId);
    if (cleanUpiId) payload.append("upiId", cleanUpiId);
    if (qrCodeFile) payload.append("qrCode", qrCodeFile);

    setLoading(true);
    try {
      const res = await fraddSettlementAccountForPayout(payload);
      if (res?.success) {
        notify(res?.message || "Account added successfully", "success");
        navigate("/money-settlement?filter=all");
      } else {
        notify(
          res?.message || "Failed to add account",
          "error"
        );
      }
    } catch (err) {
      notify(
        err?.response?.data?.message || err?.message || "Server Error. Try again later",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // ------------------- UPLOAD DOCUMENT -------------------
  const GoUploadDoc = async (data) => {
    if (!settlementId?.id) return notify("SettlementId is required", "error");

    const form = new FormData();
    form.append("settlementId", settlementId.id);
    form.append("other", data.other);
    form.append("panFile", data.panFile);

    try {
      const res = await fruploadDocSettlementAccountForPayout(form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.success) {
        notify("Account Activated Successfully", "success");
        setUploadOpen(false);
      } else {
        notify(res?.message || "Document upload failed", "error");
      }
    } catch (err) {
      notify("Server Error. Try again later", "error");
    }
  };

  // ------------------- BANK SELECTION -------------------
  const handleBankChange = (e) => {
    const id = e.target.value;
    const bank = allBanks.find((b) => Number(b.BankId) === Number(id));
    setBankId(id);
    setBankName(bank?.BankName || "");
  };

  return (
    <div className="w-full font-[Poppins]">
      <div className="ds-card p-4 md:p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl md:text-2xl font-semibold text-[var(--text-dark)]">
            Settlement Account Details
          </h2>
          <button
            type="button"
            className="ds-btn ds-btn-primary px-5 py-2 text-sm md:text-base"
            onClick={close}
          >
            CLOSE
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {/* HOLDER NAME */}
          <div className="flex flex-col">
            <label className="ds-label">
              ACCOUNT HOLDER NAME <span className="text-[var(--error-color)]">*</span>
            </label>
            <input
              type="text"
              value={holderName}
              onChange={(e) => setHolderName(e.target.value)}
              placeholder="Account Holder Name"
              className="ds-input text-sm"
              disabled={loading}
            />
          </div>

          {/* BANK SELECT */}
          <div className="flex flex-col">
            <label className="ds-label">
              SELECT OR SEARCH BANK <span className="text-[var(--error-color)]">*</span>
            </label>
            <select
              className="ds-input text-sm"
              value={bankId}
              onChange={handleBankChange}
              disabled={loading}
            >
              <option value="" disabled>
                Select Bank
              </option>
              {allBanks.map((bank) => (
                <option key={bank.BankId} value={bank.BankId}>
                  {bank.BankName}
                </option>
              ))}
            </select>
          </div>

          {/* ACCOUNT NUMBER */}
          <div className="flex flex-col">
            <label className="ds-label">
              ACCOUNT NUMBER <span className="text-[var(--error-color)]">*</span>
            </label>
            <input
              type="text"
              name="accountNumber"
              value={accountNumber}
              placeholder="Account Number"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={20}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                setAccountNumber(value);
              }}
              className="ds-input text-sm"
              disabled={loading}
            />
          </div>

          {/* CONFIRM ACCOUNT */}
          <div className="flex flex-col">
            <label className="ds-label">
              CONFIRM ACCOUNT NUMBER <span className="text-[var(--error-color)]">*</span>
            </label>
            <input
              type="text"
              name="confirmAccount"
              value={confirmAccount}
              placeholder="Confirm Account Number"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={20}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                setConfirmAccount(value);
              }}
              className="ds-input text-sm"
              disabled={loading}
            />
          </div>

          {/* IFSC + VERIFICATION BUTTON (hamesha ek hi row me) */}
          <div className="flex flex-col md:col-span-2">
            <label className="ds-label">
              IFSC CODE <span className="text-[var(--error-color)]">*</span>
            </label>

            <div className="flex flex-row items-start gap-2">
              <input
                type="text"
                value={ifsc}
                maxLength={11}
                onChange={(e) => setIfsc(e.target.value.toUpperCase())}
                placeholder="Enter IFSC Code (e.g. SBIN0001234)"
                className="ds-input flex-1 min-w-0 text-sm uppercase"
                disabled={loading}
              />

              {/* Reusable Bank Verification UI */}
              <BankVerificationBox
                verification={bankVerification}
                className="shrink-0 max-w-[45%]"
              />
            </div>
          </div>

          {/* MOBILE */}
          <div className="flex flex-col">
            <label className="ds-label">
              MOBILE NUMBER <span className="text-[var(--error-color)]">*</span>
            </label>
            <input
              type="text"
              value={mobile}
              maxLength={15}
              onChange={(e) => {
                const val = e.target.value.replace(/[^\d+]/g, "");
                setMobile(val);
              }}
              placeholder="Enter Mobile Number"
              className="ds-input text-sm"
              disabled={loading}
            />
          </div>

          {/* REMARKS */}
          <div className="flex flex-col">
            <label className="ds-label">REMARKS (Optional)</label>
            <input
              type="text"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder="Remarks"
              className="ds-input text-sm"
              disabled={loading}
            />
          </div>

          {/* UPI ID */}
          <div className="flex flex-col">
            <label className="ds-label">
              UPI ID{" "}
              <span className="text-[var(--text-muted)] text-xs">
                (UPI or QR Code required)
              </span>
            </label>
            <input
              type="text"
              value={upiId}
              onChange={(e) => setUpiId(e.target.value.trimStart())}
              placeholder="example@upi"
              className="ds-input text-sm"
              disabled={loading}
            />
          </div>

          {/* QR CODE UPLOAD */}
          <div className="flex flex-col">
            <label className="ds-label">
              UPLOAD QR CODE{" "}
              <span className="text-[var(--text-muted)] text-xs">
                (Optional, Max 5MB)
              </span>
            </label>
            <input
              type="file"
              accept="image/png,image/jpeg,image/webp"
              onChange={(event) => {
                const file = event.target.files?.[0] || null;
                if (file && file.size > 5 * 1024 * 1024) {
                  notify("QR Code image must be 5 MB or smaller", "error");
                  event.target.value = "";
                  return;
                }
                setQrCodeFile(file);
                if (file) {
                  setQrPreview(URL.createObjectURL(file));
                } else {
                  setQrPreview("");
                }
              }}
              className="ds-input text-sm"
              disabled={loading}
            />
            {qrPreview && (
              <img
                src={qrPreview}
                alt="QR Code preview"
                className="mt-2 h-32 w-32 rounded border border-[var(--border-color)] object-contain"
              />
            )}
          </div>
        </div>

        {/* ACTION BUTTONS */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mt-6">
          <button
            type="button"
            className="ds-btn ds-btn-secondary px-12 py-2 w-full sm:w-auto"
            onClick={close}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading || (bankVerification.verificationRequired && !bankVerification.ready)}
            className="ds-btn ds-btn-primary px-8 py-2 w-full sm:w-auto"
          >
            {loading ? "Adding..." : "Add Settlement Account"}
          </button>
        </div>
      </div>

      {/* UPLOAD DOC MODAL */}
      {baneId && settlementId && (
        <UploadDocPassPan
          open={uploadOpen}
          onClose={() => setUploadOpen(false)}
          onSubmit={GoUploadDoc}
          initialData={settlementId}
        />
      )}
    </div>
  );
};

export default SettlementAccount;